import React from "react";

function TermsAndCondition() {
  return (
    <>
      <div className="grid grid-cols-1 gap-6 rounded-lg border px-14 py-12 text-[#575757]">
        <h1 className="font-bold text-4xl">
          Terms and Conditions for Fund Withdrawal and Deposit
        </h1>
        <div>
          <h2 className="font-semibold">Account Verification:</h2>
            <ul className="list-disc ps-8">
            <li>
              Users must complete the account verification process before making
              any deposits or withdrawals. This typically includes providing
              identification documents and proof of address.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Deposit Procedures:</h2>
            <ul className="list-disc ps-8">
            <li>
              unds can be deposited into the forex CRM via approved payment
              methods specified by the platform.
            </li>
            <li>
              The minimum and maximum deposit amounts should be clearly stated.
            </li>
            <li>
              Deposits may be subject to processing fees which will be disclosed
              to the user.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Withdrawal Procedures:</h2>
            <ul className="list-disc ps-8">
            <li>
              Users can request withdrawals through the CRM's designated
              withdrawal interface.
            </li>
            <li>
              Withdrawal requests must be made using the same method and account
              used for deposits.
            </li>
            <li>The minimum withdrawal amount should be specified.</li>
            <li>
              Withdrawal requests may take a certain number of business days to
              process.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Withdrawal Fees and Charges:</h2>
            <ul className="list-disc ps-8">
            <li>
              The forex CRM may impose withdrawal fees based on the chosen
              withdrawal method.
            </li>
            <li>
              Any third-party charges incurred during the withdrawal process
              will be the responsibility of the user.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">
            Anti-Money Laundering (AML) and Know Your Customer (KYC) Policies:
          </h2>
            <ul className="list-disc ps-8">
            <li>
              Users must comply with AML and KYC policies when depositing and
              withdrawing funds. This includes providing accurate and up-to-date
              personal information.
            </li>
            <li>
              The forex CRM reserves the right to request additional information
              or documentation to verify a user's identity.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Currency Exchange Rates:</h2>
            <ul className="list-disc ps-8">
            <li>
              For deposits made in a different currency than the account base
              currency, the CRM will apply prevailing exchange rates.
            </li>
            <li>
              Exchange rate fluctuations may affect the final deposited or
              withdrawn amount.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Processing Time:</h2>
            <ul className="list-disc ps-8">
            <li>
              Deposits and withdrawals are subject to processing times based on
              the payment method and any necessary verification checks.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Cancellation and Refund Policy:</h2>
            <ul className="list-disc ps-8">
            <li>
              Users may have the option to cancel withdrawal requests within a
              specified timeframe.
            </li>
            <li>
              Refunds for cancelled transactions will be subject to the forex
              CRM's policies.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Risk Disclosure:</h2>
            <ul className="list-disc ps-8">
            <li>
              Users should understand the risks associated with forex trading
              and the potential loss of deposited funds.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Dispute Resolution:</h2>
            <ul className="list-disc ps-8">
            <li>
              Procedures for dispute resolution in cases of transactional errors
              or discrepancies should be clearly outlined.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Prohibited Activities:</h2>
            <ul className="list-disc ps-8">
            <li>
              Clearly state any activities that are prohibited, such as using
              third-party accounts for deposits or withdrawals.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold">Changes to Terms and Conditions:</h2>
            <ul className="list-disc ps-8">
            <li>
              The forex CRM reserves the right to modify or update these terms
              and conditions at any time, with appropriate notice to users.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default TermsAndCondition;
